import axios from "axios";
import { all, call, put, takeEvery } from "redux-saga/effects";

import { LogoutActionCreator, SetAuthTokenActionCreator } from "./actions";

const TOKEN_KEY = "AUTH_TOKENS";

function* tokenPersistence() {
  const val = window.localStorage.getItem(TOKEN_KEY);
  if (val) {
    yield put(SetAuthTokenActionCreator(JSON.parse(val)));
  }
  yield all([
    takeEvery(SetAuthTokenActionCreator, (data: ReturnType<typeof SetAuthTokenActionCreator>) => {
      axios.defaults.headers.common.authorization = data.payload.access_token;
      window.localStorage.setItem(TOKEN_KEY, JSON.stringify(data.payload));
    }),
    takeEvery(LogoutActionCreator, () => {
      axios.defaults.headers.common.authorization = "";
      window.localStorage.removeItem(TOKEN_KEY);
    }),
  ]);
}

export function* authSagas() {
  yield all([call(tokenPersistence)]);
}
